// This file was automatically generated from tourguide.homeInfoSplash.html.
// Please don't edit this file by hand.

goog.provide('el8.template.tourguide.homeInfoSplash');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.tourguide.homeInfoSplash.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="info-splash-content"><div class="splashCloseTrigger close-trigger"></div><div class="SplashHeading">Practice Home</div><div class="SplashSubheading">click each section title to learn more</div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.tourguide.homeInfoSplash.schedulerBlock = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="SplashBlockContentsScheduler"><p class="SplashBlockHeading Scheduler"><a class="el8LightLink" target="_blank" rel="noopener" href="https://help.elationhealth.com/s/article/how-to-use-elation-calendar">Calendar</a></p><span class="SplashBlockText">Manage your appointments</span></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.tourguide.homeInfoSplash.writeSeeBarBlock = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="SplashBlockContentsShortcut"><p class="SplashBlockHeading Shortcut"><a class="el8LightLink" target="_blank" rel="noopener" href="https://help.elationhealth.com/s/article/practice-home-introduction">Navigate Practice Home</a></p></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.tourguide.homeInfoSplash.patientSearchBlock = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="SplashBlockContentsPatientSearch"><p class="SplashBlockHeading Search">Search for a patient</p></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.tourguide.homeInfoSplash.reqActQueueBlock = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="SplashBlockContentsQueue"><p class="SplashBlockHeading RequiringActions"><a class="el8LightLink" target="_blank"  rel="noopener"href="https://help.elationhealth.com/s/article/the-requiring-actions-queue-follow-up-on-action-items">REQUIRING ACTIONS QUEUE</a></p><span class="SplashBlockText">Your personal, up-to-date inbox</span></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.tourguide.homeInfoSplash.infoSplashBlock = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="SplashBlockInfo"><p class="SplashBlockText">Bring up this page map again</p></div>');
  if (!opt_sb) return output.toString();
};
